import { User } from 'firebase/auth';
import { useState, useCallback, useEffect } from 'react';

import { getCoupons } from '~/restApi/coupon';

import { PLATFORM_ID } from '~/globalVariables';

import { Coupon } from '~/types/coupon';
import { FetchingDataStatus } from '~/types/utilities';

export default function useCoupons(auth: User | null) {
  const [coupons, setCoupons] = useState<Array<Coupon>>([]);
  const [couponFetchingStatus, setCouponFetchingStatus] = useState(FetchingDataStatus.INIT);

  const handleGetCoupons = useCallback(async (platformId: string, auth: User) => {
    try {
      setCouponFetchingStatus(FetchingDataStatus.LOADING);
      const res = await getCoupons(platformId, auth);
      setCoupons(res);
      setCouponFetchingStatus(FetchingDataStatus.SUCCESS);
    } catch (err) {
      setCouponFetchingStatus(FetchingDataStatus.FAIL);
    }
  }, []);

  useEffect(() => {
    if (auth) {
      handleGetCoupons(PLATFORM_ID, auth);
    }
  }, [handleGetCoupons, auth]);

  return { coupons, couponFetchingStatus };
}
